import { useEffect } from 'react'

import { useTravelSearchContext } from '../context/TravelSearchProvider'
import { isPetsOnlyAllowedInVehicle } from '../Utils/passengers'
import { isMultipleVehiclesSupportedWithRoute, isMultipleVehiclesSupportedWithVehicleType } from '../Utils/vehicles'

export const useSyncTravelSearchSettings = () => {
  const { dispatch, state } = useTravelSearchContext()

  const routeCode = state.selectedRoute?.routeCode
  const vehicleCode = state.selectedVehicle?.code

  useEffect(() => {
    if (!routeCode || !vehicleCode) return

    const multiVehiclesWithRoute = isMultipleVehiclesSupportedWithRoute(routeCode)
    const multiVehiclesWithVehicle = isMultipleVehiclesSupportedWithVehicleType(vehicleCode)
    const shouldSupportMultipleVehicles = multiVehiclesWithRoute && multiVehiclesWithVehicle

    if (state.multipleVehiclesSupported !== shouldSupportMultipleVehicles) {
      dispatch({
        supported: shouldSupportMultipleVehicles,
        type: 'SET_MULTIPLE_VEHICLES_SUPPORTED',
      })
    }

    if (!shouldSupportMultipleVehicles && state.multipleVehiclesChecked) {
      dispatch({ checked: false, type: 'SET_MULTIPLE_VEHICLES_CHECKED' })
    }

    const petsOnlyAllowed = isPetsOnlyAllowedInVehicle(routeCode)
    dispatch({
      allowed: petsOnlyAllowed,
      type: 'SET_PETS_ONLY_ALLOWED_IN_VEHICLE',
    })
  }, [
    routeCode,
    vehicleCode,
    state.routesApiData,
    state.vehicleApiLoading,
    state.multipleVehiclesChecked,
    state.multipleVehiclesSupported,
    dispatch,
  ])

  const firstRouteReturnRequired = state.routesApiData?.categories?.[0]?.routes?.[0]?.returnRequired

  useEffect(() => {
    const returnRequired = state.selectedRoute?.returnRequired ?? firstRouteReturnRequired ?? false

    if (returnRequired !== state.disableOneWay) {
      dispatch({ disabled: returnRequired, type: 'SET_DISABLE_ONE_WAY' })
    }
  }, [state.selectedRoute?.returnRequired, firstRouteReturnRequired, state.disableOneWay, dispatch])
}
